import { render, staticRenderFns } from "./Popup-message.vue?vue&type=template&id=15a86f09&scoped=true&"
import script from "./Popup-message.vue?vue&type=script&lang=ts&"
export * from "./Popup-message.vue?vue&type=script&lang=ts&"
import style0 from "./Popup-message.vue?vue&type=style&index=0&id=15a86f09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a86f09",
  null
  
)

export default component.exports